import BANNER from "./banner.jpg";
import LOADER from "./loader.gif"
export default {
  BANNER,
  LOADER
};